import React from "react";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import UIModalDuck from "stores/ducks/ui/UIModal.duck";
import { store } from "stores/store.js"
import "./ModalContainer.css";
import ModalContent from "./modules/content/ModalContent";

export const moduleName = "Modal";

export class ModalContainer extends React.Component<{
  isOpen: boolean;
  dispatch: any;
  title: any;
}> {
  constructor(props) {
    super(props);
    // this.computeModalClass = this.computeModalClass.bind(this);
    this.backGroundClick = this.backGroundClick.bind(this);
  }

  /**
   * Used to compute className based on modal state - isOpen?
   */
  // public computeModalClass() {
  //   const { isOpen } = this.props;
  //   if (!isOpen) {
  //     return blissModule(moduleName);
  //   }
  //   return blissModule(moduleName, "open");
  // }

  public backGroundClick() {
    store.dispatch(UIModalDuck.closeModal());
  }

  public render() {

    const { isOpen } = this.props;

    if (!isOpen) {
      return null;
    }

    // console.log(this.props.title)

    return (
      <div>
        <Modal isOpen={isOpen} toggle={this.backGroundClick} style={{ borderRadius: '20px', backgroundColor: '#f8f8f8', width: 650, maxWidth: '95%' }}>
          <ModalHeader className="sexyBlack">{this.props.title}
          </ModalHeader>
          <ModalBody>
            <ModalContent />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isOpen: UIModalDuck.isOpen(state),
    title: UIModalDuck.getOwnState(state).title
  };
};

export default connect(mapStateToProps)(ModalContainer);




// WEBPACK FOOTER //
// ./src/components/modal/ModalContainer.tsx